import React, { PropsWithChildren, ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";

const NavigationScrollTop: React.FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (children as any) || null;
};

export default NavigationScrollTop;
